import React from 'react';

function sumValues(obj) {
    return Object.values(obj || {}).reduce((acc, n) => acc + (n || 0), 0);
}

function avg7dTat(dailyDocs) {
    // dailyDocs come back ordered by date desc (newest first)
    const last7 = dailyDocs.slice(0, 7);
    const totalMs = last7.reduce((a, d) => a + (d.total_processing_time_ms || 0), 0);
    const total = last7.reduce((a, d) => a + (d.total_cases_processed || 0), 0);
    if (!total) return null;
    return Math.round((totalMs / total / 1000 / 60) * 10) / 10;
}

export default function DashboardHeroCards({ currentState, dailyDocs = [] }) {
    const today = new Date().toISOString().slice(0, 10);
    const todayDoc = dailyDocs.find((d) => d.date === today);
    const todayCount = todayDoc?.total_cases_created || 0;
    const openTotal = sumValues(currentState?.open_by_admission_status);
    const avgTat = avg7dTat(dailyDocs);
    const stuck = currentState?.open_stuck_over_3_days || 0;

    return (
        <div className="dashboard-hero-cards">
            <div className="hero-card">
                <div className="hero-card-num">{todayCount}</div>
                <div className="hero-card-lbl">Today</div>
            </div>
            <div className="hero-card">
                <div className="hero-card-num">{openTotal}</div>
                <div className="hero-card-lbl">Open</div>
            </div>
            <div className="hero-card">
                <div className="hero-card-num">{avgTat !== null ? `${avgTat}m` : '—'}</div>
                <div className="hero-card-lbl">Avg TAT (7d)</div>
            </div>
            <div className="hero-card">
                <div className="hero-card-num">{stuck}</div>
                <div className="hero-card-lbl">Stuck &gt;3d</div>
            </div>
        </div>
    );
}
